import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxData, ReadOnlyData } from './components';

const dataPresenterType = {
  CHECKBOX: function checkbox(props) { return <CheckboxData {...props} /> },
  DEFAULT: function defaultData(props) { return <ReadOnlyData {...props} /> }
};

export const RowData = (props) => {
  const { headers, data } = props;

  const rowDataPayload = (header, index) => {
    if (!data) {
      return {
        isHeader: true,
        customProps: header.props,
        data: header,
        dataKey: 'text',
        auxKey: header.auxKey,
        key: `HeaderData_${header.key}_${index}`
      };
    }

    return {
      icon: header.icon,
      customProps: header.props,
      data,
      dataKey: header.key,
      auxKey: header.auxKey,
      key: `RowData_${header.key}_${index}`
    };
  };

  return headers.map(header => dataPresenterType[header.type](rowDataPayload(header)));
};

RowData.propTypes = {
  data: PropTypes.object,
  headers: PropTypes.array.isRequired
};
